import React from 'react'

import { Box } from 'app/components/design-system-components'
import ContactDetails from 'app/match/apply/application_summary_before_submit/shared_components/contact_container/component'
import { relationshipTypesEmergencyContact } from 'app/sm/helpers'

const SummaryEmergencyContactBox = ({ contact, from = '' }) => {
  const {
    firstName = '',
    lastName = '',
    phoneNumber = '',
    email = '',
    relationship = 0,
    address = {},
  } = contact || {}
  let addressString = ''
  if (Object.keys(address).length !== 0 && address?.friendlyName?.length > 0) {
    addressString = `${address?.friendlyName}, ${address.suburb}, ${address.state}, ${address.postcode}`
  }

  const extraNameString = (
    <>
      <Box>{relationshipTypesEmergencyContact[relationship]}</Box>
      {addressString && <Box>{addressString}</Box>}
    </>
  )
  const fromRenterSummary = from === 'renterSummary'
  return (
    <div
      className={`bc-hub-item-link card-block pdf-width-50p ${
        fromRenterSummary && 'no-box-shadow p0'
      }`}
    >
      <div className="card-wrapper">
        <div className="card-details w0p card-info">
          <content>
            <ContactDetails
              firstName={firstName}
              lastName={lastName}
              phoneNumber={phoneNumber}
              email={email}
              extraName={extraNameString}
              showContactLabel={false}
            />
          </content>
        </div>
      </div>
    </div>
  )
}

export default SummaryEmergencyContactBox
